module.exports = __webpack_public_path__ + "static/img/all-project.3741e837.svg";